import { MedicationStatement } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const medicationAdapter = createEntityAdapter({
  selectId: (medication: MedicationStatement) => medication.id!,
});

const reducers = {
  loadMedication: medicationAdapter.setAll,
  createManyMedication: medicationAdapter.addMany,
  createMedication: medicationAdapter.addOne,
  removeMedication: medicationAdapter.removeOne,
  updateMedication: medicationAdapter.updateOne,
};

export const medicationSlice = createSlice({
  name: "patientMedication",
  initialState: medicationAdapter.getInitialState(),
  reducers,
});

export const {
  loadMedication,
  createMedication,
  createManyMedication,
  removeMedication,
  updateMedication,
} = medicationSlice.actions;

const selectMedicationEntities = (state: RootState) => state.clientMedications.entities;

export const selectMedicationList = createSelector(
  [selectMedicationEntities],
  (patientMedicationEntities): MedicationStatement[] => Object.values(patientMedicationEntities),
);

export default medicationSlice.reducer;
